"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminOrder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const actions_1 = __importDefault(require("@src/actions"));
const types_1 = require("@src/types");
const useConfig_1 = require("@src/hooks/useConfig");
const Api = __importStar(require("@src/api"));
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const premium_subscription_1 = require("@src/helpers/premium-subscription");
const react_query_1 = require("react-query");
const AdminOrderPayments_1 = require("./AdminOrderPayments");
const AdminOrderSummary_1 = require("./AdminOrderSummary");
const AdminOrderBillingProfile_1 = require("./AdminOrderBillingProfile");
const AdminOrderProducts_1 = require("./AdminOrderProducts");
const AdminOrderCoupon_1 = require("./AdminOrderCoupon");
const AdminOrderErrorAlert_1 = require("./AdminOrderErrorAlert");
const AdminOrder = ({ productId = types_1.ProductId.offerCredits, amount = 1, offerId, onOrderSuccess, setWasCouponApplied, companyOutOfContext, }) => {
    var _a, _b;
    const [couponInputValue, setCouponInputValue] = react_1.default.useState('');
    const [appliedCouponCode, setAppliedCouponCode] = react_1.default.useState(null);
    const [isCouponLoading, setIsCouponLoading] = react_1.default.useState(false);
    const [isOrderLoading, setIsOrderLoading] = react_1.default.useState(false);
    const [discount, setDiscount] = react_1.default.useState(0);
    const dispatch = (0, react_redux_1.useDispatch)();
    const config = (0, useConfig_1.useConfig)();
    const history = (0, react_router_1.useHistory)();
    const location = (0, react_router_1.useLocation)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const intl = (0, react_intl_1.useIntl)();
    const { companyInfo, setIsCompanyPremiumActivatedDialogOpen } = (0, admin_context_1.useAdminContextValue)();
    const { companyPaymentSubscriptions, payment_method_token: companyPaymentMethodToken } = companyOutOfContext || companyInfo;
    const [selectedBillingProfile, setSelectedBillingProfile] = react_1.default.useState();
    const [billingProfiles, setBillingProfiles] = react_1.default.useState([]);
    const hasAbroadBillingProfile = (selectedBillingProfile === null || selectedBillingProfile === void 0 ? void 0 : selectedBillingProfile.country) !== config.countryCode;
    const isAllowedToMakeThePurchase = !hasAbroadBillingProfile || (hasAbroadBillingProfile && (selectedBillingProfile === null || selectedBillingProfile === void 0 ? void 0 : selectedBillingProfile.tinVat));
    const hasActiveSubscription = (0, premium_subscription_1.getHasCompanyActivePremiumCompanyProfileSubscription)(companyPaymentSubscriptions);
    const orderParams = react_1.default.useMemo(() => ({
        productAmounts: [
            {
                productId,
                amount,
            },
        ],
        appliedCouponCode,
        hasActiveSubscription,
        offerId,
    }), [productId, amount, appliedCouponCode]);
    const { data: orderContent, error, isFetching: isOrderContentFetching, } = (0, useAppQuery_1.useAppQuery)([queries_1.Queries.getOrder, orderParams], () => Api.Admin.getOrderContent({ orderParams }), {
        keepPreviousData: true,
    });
    const getBillingProfiles = async () => {
        try {
            const { allBillingProfilesById } = await Api.CompanyBillingProfile.getBillingProfiles();
            setBillingProfiles(allBillingProfilesById);
            const defaultBillingProfile = allBillingProfilesById.find(profile => profile.isDefault);
            setSelectedBillingProfile(defaultBillingProfile);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        }
    };
    const validateCoupon = async (couponCode = couponInputValue) => {
        var _a, _b;
        try {
            setIsCouponLoading(true);
            const productIds = orderContent ? orderContent.products.map(({ id }) => id) : [];
            const coupon = await Api.Admin.validateCoupon(couponCode, productIds, offerId);
            setWasCouponApplied === null || setWasCouponApplied === void 0 ? void 0 : setWasCouponApplied(true);
            if (orderContent && (coupon.freeCreditsCount || coupon.freeMonthsPeriod || coupon.freeOfferPromotion)) {
                await Api.Admin.applyCoupon(couponCode, productIds, offerId);
                if (coupon.productId === types_1.ProductId.offerCredits) {
                    history.pushLocalized('/admin');
                    dispatch(actions_1.default.adminToggleCreditsReplenishedDialog(true));
                }
                if (coupon.productId === types_1.ProductId.offerPromotion) {
                    onOrderSuccess === null || onOrderSuccess === void 0 ? void 0 : onOrderSuccess();
                    history.pushLocalized('/admin');
                    antd_1.notification.success({
                        message: intl.formatMessage({ id: 'admin.order.coupon.offer_promotion_activated' }),
                    });
                }
                if (coupon.productId === types_1.ProductId.companyPremium) {
                    onOrderSuccess === null || onOrderSuccess === void 0 ? void 0 : onOrderSuccess();
                    history.pushLocalized('/admin');
                    setIsCompanyPremiumActivatedDialogOpen(true);
                    queryClient.invalidateQueries(queries_1.Queries.getCompany);
                }
                return;
            }
            setDiscount(coupon.discountPercentage);
            setAppliedCouponCode(couponCode);
            setCouponInputValue('');
            antd_1.notification.success({
                message: intl.formatMessage({ id: 'admin.order.coupon.applied' }),
            });
        }
        catch (err) {
            const errorCode = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code;
            switch (errorCode) {
                case types_1.CouponResponses.ALREADY_USED:
                    antd_1.notification.error({
                        message: intl.formatMessage({ id: 'admin.order.coupon.already_used' }),
                    });
                    break;
                case types_1.CouponResponses.EXPIRED:
                    antd_1.notification.error({
                        message: intl.formatMessage({ id: 'admin.order.coupon.expired' }),
                    });
                    break;
                case types_1.CouponResponses.NOT_APPLICABLE:
                    antd_1.notification.error({
                        message: intl.formatMessage({ id: 'admin.order.coupon.not_applicable' }),
                    });
                    break;
                default:
                    antd_1.notification.error({
                        message: intl.formatMessage({ id: 'admin.order.coupon.invalid_code' }),
                    });
            }
        }
        finally {
            setIsCouponLoading(false);
        }
    };
    const init = async () => {
        dispatch(actions_1.default.myCompanyInfoInitStart());
        getBillingProfiles();
    };
    react_1.default.useEffect(() => {
        const { discountCode } = history.getQuery();
        if (discountCode) {
            setCouponInputValue(discountCode);
            validateCoupon(discountCode);
        }
    }, [location.search]);
    react_1.default.useEffect(() => {
        init();
    }, []);
    const errorCode = ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) || null;
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [errorCode && (0, jsx_runtime_1.jsx)(AdminOrderErrorAlert_1.AdminOrderErrorAlert, { code: errorCode }), (0, jsx_runtime_1.jsxs)(antd_1.Row, { gutter: [16, 16], children: [(0, jsx_runtime_1.jsxs)(antd_1.Col, { className: "flex-col", xs: 24, md: 14, children: [(0, jsx_runtime_1.jsx)(AdminOrderProducts_1.AdminOrderProducts, { orderContent: orderContent }), (0, jsx_runtime_1.jsx)(AdminOrderCoupon_1.AdminOrderCoupon, { isApplyDisabled: !orderContent || isOrderLoading || isOrderContentFetching, appliedCouponCode: appliedCouponCode, isCouponLoading: isCouponLoading, setAppliedCouponCode: setAppliedCouponCode, setCouponInputValue: setCouponInputValue, validateCoupon: validateCoupon, couponInputValue: couponInputValue, setDiscount: setDiscount })] }), (0, jsx_runtime_1.jsx)(antd_1.Col, { className: "flex-1", xs: 24, md: 10, children: (0, jsx_runtime_1.jsx)(AdminOrderBillingProfile_1.AdminOrderBillingProfile, { billingProfiles: billingProfiles, selectedBillingProfile: selectedBillingProfile, setSelectedBillingProfile: setSelectedBillingProfile }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, children: (0, jsx_runtime_1.jsx)(AdminOrderSummary_1.AdminOrderSummary, { orderContent: orderContent, discount: discount, hasAbroadBillingProfile: hasAbroadBillingProfile, loading: isOrderContentFetching }) })] }), isAllowedToMakeThePurchase && discount !== 100 && ((0, jsx_runtime_1.jsx)(AdminOrderPayments_1.AdminOrderPayments, { orderContent: orderContent, orderParams: orderParams, selectedBillingProfile: selectedBillingProfile, isOrderLoading: isOrderLoading || isOrderContentFetching, appliedCouponCode: appliedCouponCode, setIsOrderLoading: setIsOrderLoading, offerId: offerId, onOrderSuccess: onOrderSuccess, companyPaymentMethodToken: companyPaymentMethodToken })), !isAllowedToMakeThePurchase && ((0, jsx_runtime_1.jsx)(elements_1.Panel, { className: "m-t-m", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-col flex-center", children: [(0, jsx_runtime_1.jsx)(elements_1.Alert, { className: "m-b-m", type: "warning", message: (0, jsx_runtime_1.jsxs)("div", { className: "flex-col", children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.missing_tin_vat" }), billingProfiles.length > 1 && ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.change_billing_profile" }))] }) }), (0, jsx_runtime_1.jsx)(elements_1.Link, { to: `/admin/platby/fakturacny-profil/${selectedBillingProfile === null || selectedBillingProfile === void 0 ? void 0 : selectedBillingProfile.id}`, children: (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "middle", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.go_to_billing_profile" }) }) })] }) }))] }));
};
exports.AdminOrder = AdminOrder;
